<div  class="ClsTransactionOTPModel p-0 ModalNPS" appDisabledRightClick>
    <div class="modal-dialog">
        <div class="modal-content AlertModalContentCls MainBgOtp">
            <div class="modal-body p-0">
                <div class="MainBg">
                <div class="MainInnerFormWithoutFlex" style="background-color: transparent;">
                    <div class="OTPOuter BoxShadow text-center">
                        <div class="d-flex justify-content-end" *ngIf="IsShowCartMessage">
                            <img src="../../../assets/images/BOB_World.png" class="text-right" style="width: 130px !important;height :200px !important; "/>
                        </div>
                        <button type="button" *ngIf="isShowCloseButton" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="IsForVerification ? LogoutFunction() : ResetOTP()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                        <div class="head">Verification</div>
                        <div class="mob" *ngIf="onlyEmail == false && onlyMobile == false && !IsShowCartMessage && !IsMobileEmail">OTP has been sent to your registered Mobile no {{ValueMasking(MobileNo, "Mobile")}} 
                            <!-- <div *ngIf="this.EmailID!=null && this.EmailID!=''"> and EmailID {{ValueMasking(EmailID, "Email")}}</div> -->
                         </div>
                         <!-- <div class="mob" *ngIf="IsMobileEmail == true && !IsShowCartMessage">OTP has been sent to your registered Mobile no {{ValueMasking(MobileNo, "Mobile")}} 
                            <div *ngIf="this.EmailID!=null && this.EmailID!=''"> and EmailID {{ValueMasking(EmailID, "Email")}}</div>
                         </div> -->
                        <div class="mob" *ngIf="onlyEmail == true && !IsShowCartMessage ">OTP has been sent to your registered Email-ID : {{ValueMasking(EmailID, "Email")}}</div>
                        <div class="mob" *ngIf="onlyMobile == true && !IsShowCartMessage">OTP has been sent to your registered Mobile no.: {{ValueMasking(MobileNo, "Mobile")}}</div>
                        <div class="mob" *ngIf="IsShowCartMessage && onlyEmail == true ">To Access Your Investment Cart , Please Enter The One-Time Password(OTP) Sent To Your Registered Email Address
                             <div *ngIf="this.EmailID!=null && this.EmailID!=''"> {{EmailID}}</div>
                        </div>
                        <div class="mob" *ngIf="IsMobileEmail && !IsShowCartMessage ">OTP has been sent to your registered Mobile no.: {{ValueMasking(MobileNo, "Mobile")}} & Email-ID : {{ValueMasking(EmailID, "Email")}}</div>
                        <div class="leb">Enter OTP</div>
                        <div>
                            <form autocomplete="off" [formGroup]="OTPForm">
                                <ng-otp-input #ngOtpInput
                                [config]="config"
                                    [ngClass]="{ 'is-invalid': OTPFormSubmitted && o.OTP.errors }"
                                    (onInputChange)="onOtpChange($event)"></ng-otp-input>
                                <!-- (keypress)="ValidatePattern('Number',$event)" -->
                                <div *ngIf="OTPFormSubmitted && o.OTP.errors" class="invalid-feedback">
                                    <div *ngIf="o.OTP.errors.required">Please enter OTP</div>
                                </div>
                            </form>
                        </div>

                        <div>
                            <button class="res" (click)='ResendOTP()' disabled='true'><strong>Resend OTP</strong></button>
                        </div>
                        <div class="time">
                            <div id='Time'></div>
                        </div>
                        <!-- <div *ngIf="OFSClient==4">This order has been reported to exchange. Please enter the OTP to proceed and make payment. In case the payment is not completed, the order will remain open with exchange till T+1 working day and shall be adjusted against any other payment on FIFO (first in first out) basis.</div> -->
                        <div><button type="submit" class="CommonSubmitButton" (click)="onSubmitOTP();"
                                [disabled]="!OTPForm.valid || !ShowVeirfy">Submit</button></div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
  </div>

  <div class="modal mdlCls" id="AlertModalprofilemodels" appDisabledRightClick data-backdrop='static' data-keyboard='false'>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content AlertModalContentCls">
        <div class="modal-header AlertModalHeader">Important Message</div>
        <div id="AlertModalContentmodels" class="modal-body AlertModalBody"></div>
        <div class="modal-footer AlertModalFooter">
          <button type="button" data-dismiss="modal" class="CursorPointer">Okay</button>
        </div>
      </div>
    </div>
  </div>

